import { useMediaQuery } from "@mui/material";
import { Shirt } from "../../entities/Shirt";
import Top10ElementShirt from "../Top10ElementShirt/Top10ElementShirt";
import Top10ElementAdd from "../Top10ElementAdd/Top10ElementAdd";
import Top10ElementMobile from "../Top10ElementMobile/Top10ElementMobile";

interface Top10ElementProps {
  shirt?: Shirt;
  position: number;
  add?: Function;
  remove?: Function;
  shirtCollection: Array<Shirt>;
  userName: string;
}

export const Top10Element = ({
  shirt,
  position,
  add,
  remove,
  shirtCollection,
  userName,
}: Top10ElementProps) => {
  const matches = useMediaQuery("(min-width:600px)");

  return shirt ? (
    matches ? (
      <Top10ElementShirt
        userName={userName}
        shirt={shirt}
        position={position}
        remove={remove}
      />
    ) : (
      <Top10ElementMobile
        userName={userName}
        shirt={shirt}
        position={position}
        remove={remove}
      />
    )
  ) : (
    <Top10ElementAdd
      position={position}
      add={add}
      shirtCollection={shirtCollection}
    />
  );
};

export default Top10Element;
